'use client';

import { assignInlineVars } from '@vanilla-extract/dynamic';
import { Property } from 'csstype';
import React from 'react';

import * as styles from './spinner.css';

export const Spinner: React.FC<{
  size?: Exclude<Property.FontSize, 0>;
  marginTop?: Exclude<Property.MarginTop, 0>;
  marginBottom?: Exclude<Property.MarginBottom, 0>;
}> = ({ size = 'inherit', marginTop = '0', marginBottom = '0' }) => (
  <div
    className={styles.spinner}
    style={assignInlineVars({
      [styles.sizeVar]: size,
      [styles.marginTopVar]: marginTop,
      [styles.marginBottomVar]: marginBottom,
    })}
  />
);
